import React from "react";

import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
} from "@chakra-ui/react";

import Markdown from "react-markdown";

import ThemeColorConstant from "constants/ThemeColorsConstant";

import summary_clipboard_icon from "assets/images/icons/summary_clipboard_icon.png";
import CopyToClipboard from "components/CopyToClipboard/CopyToClipboard";

export default function SummaryDrawer(props) {
  const { isOpen, onClose } = props;

  const markdown = props?.summaryText;
  return (
    <Drawer isOpen={isOpen} onClose={onClose} size={"md"}>
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />

        <DrawerHeader sx={{ bg: ThemeColorConstant.secondaryColor }}>
          <div className="flex flex-row gap-3 ">
            <div className="flex flex-col justify-center text-white ">
              <img src={summary_clipboard_icon} className="h-[20px] w-[20px]" />
            </div>
            <h3>Files Summary</h3>
          </div>
        </DrawerHeader>
        {/* </div> */}

        <DrawerBody>
          <div className="flex flex-row justify-between my-4 ">
            <div className="my-auto">
              <h4>Key Changes</h4>
            </div>
            <CopyToClipboard text={markdown} />
          </div>
          <div className="list-disc list-inside ">
            {/* <div dangerouslySetInnerHTML={{ __html: props?.summaryText }} /> */}

            <Markdown>{markdown}</Markdown>
          </div>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
